var map = {
	"./de-DE.json": [
		"0pD4",
		7
	],
	"./en-EN.json": [
		"Gpqy",
		6
	],
	"./fr-FR.json": [
		"Bj9a",
		5
	],
	"./ru-RU.json": [
		"T9TL",
		4
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "S/aJ";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/lang lazy ^\.\/.*\.json$
// module id = S/aJ
// module chunks = 12